import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TripTypeOptions } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  handleUpdateSearchApiFailure,
  prepareUpdateSearchApiPayload
} from '../../../adapters/book-widget-postData/update-search-api.adapter';
import { prepareUpdateSearchApiMultiCityPayload } from '../../../adapters/book-widget-postData/update-search-multi-city-api.adapter';
import { formatErrorCode } from '../../../adapters/utils/utils.adapter';
import { BOOK_WIDGET_ERROR_CODES } from '../../../constants/error-codes.constants';
import {
  UpdateSearchApiMultiCityPayload,
  UpdateSearchApiPayload
} from '../../../models/states/update-search-state.interfaces';
import { UpdateSearchApiService } from '../../../services/update-search.service';
import * as fromErrorHandlerActions from '../../actions/error-handler.actions';
import * as fromPostDataActions from '../../actions/post-data.action';
import { LoadUpdateSearchApi } from '../../actions/post-data.action';

@Injectable({
  providedIn: 'root'
})
export class UpdateSearchApiEffects {
  loadUpdateSearchApi$ = createEffect(
    (): Observable<Action> =>
      this.Actions$.pipe(
        ofType(LoadUpdateSearchApi),
        switchMap(({ postDataSearch, redirectToPage, cacheKeySuffix }) => {
          const isTripTypeMultiCity =
            postDataSearch.tripType === TripTypeOptions.MULTI_CITY;
          const payload = isTripTypeMultiCity
            ? prepareUpdateSearchApiMultiCityPayload(postDataSearch)
            : prepareUpdateSearchApiPayload(postDataSearch);
          if (!payload) {
            return of(
              fromErrorHandlerActions.HandleError({
                errorCode: formatErrorCode(
                  BOOK_WIDGET_ERROR_CODES.UPDATE_SEARCH_PAYLOAD_ERROR
                ),
                error: BOOK_WIDGET_ERROR_CODES.UPDATE_SEARCH_PAYLOAD_ERROR
              }),
              handleUpdateSearchApiFailure(redirectToPage, cacheKeySuffix)
            );
          }
          return this.UpdateSearchApiService.updateSearch(
            payload as UpdateSearchApiPayload | UpdateSearchApiMultiCityPayload,
            isTripTypeMultiCity
          ).pipe(
            map(() =>
              fromPostDataActions.ReadyToNavigateSearch({
                redirectToPage: redirectToPage,
                cacheKeySuffix
              })
            ),
            catchError((error: HttpErrorResponse) => {
              return of(
                fromErrorHandlerActions.HandleError({
                  errorCode: formatErrorCode(
                    BOOK_WIDGET_ERROR_CODES.UPDATE_SEARCH_API_ERROR,
                    error?.status
                  ),
                  error: BOOK_WIDGET_ERROR_CODES.UPDATE_SEARCH_API_ERROR
                }),
                handleUpdateSearchApiFailure(redirectToPage, cacheKeySuffix)
              );
            })
          );
        })
      )
  );

  constructor(
    private Actions$: Actions,
    private UpdateSearchApiService: UpdateSearchApiService
  ) {}
}
